"use client";

import React ,{useState} from "react";
import _ from "lodash";

import {type IAssetFilter, AssetFilters} from "@isudio/data";
import {Button, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem} from "../../";

export interface FilterDropdownProps {
  filters: IAssetFilter[];
  onChange?: (filter: IAssetFilter) => void;
}

export function FilterDropdown({
                                 filters = AssetFilters,
                                 onChange,
                               }: FilterDropdownProps) {
  const defaultFilter: IAssetFilter | undefined = _.find(filters, {default: true});
  const [selected, setSelected] = useState<IAssetFilter | undefined>(defaultFilter ?? filters[0]);

  const onSelect = (filter: IAssetFilter) => {
    setSelected(filter);
    onChange?.(filter);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        asChild>
        <Button
          variant="vanilla"
          className="h-8 flex items-center gap-2 border-none bg-bluegray-darker text-sm text-white rounded-[25px] cursor-pointer">
          <i className="ml-2 fa-duotone fa-light fa-filter text-sm text-bluegray-lighter"/>
          <span className="w-23 text-xs">{selected?.label}</span>
          <i className="mr-2 fa-duotone fa-light fa-chevron-down text-xs text-bluegray-lighter"/>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        className="w-30 bg-bluegray-darker rounded-[6px] shadow-[1px_1px_2px_1px_rgba(105,120,127,1)]!">
        {filters.map((filter: IAssetFilter) => (
          <DropdownMenuItem
            key={filter.assetType}
            onClick={() => onSelect(filter)}
            className={`flex justify-between text-xs transition duration-200 ${selected?.assetType === filter.assetType ? 'text-white bg-bluegray-light/30' : 'text-bluegray-lighter hover:text-generic-hover hover:scale-105 hover:bg-bluegray-light/12 hover:-translate-y-0.5'}`}
          >
            {filter.label}
            {selected?.assetType === filter.assetType &&
              <i className="fa-duotone fa-light fa-check text-xs text-bluegray-lighter"/>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
